export default __webpack_public_path__ + "static/media/daniel-olahs.fe7b9cc0.jpg";